var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconOrganize = function SvgIconOrganize(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3080DF",
    fillRule: "evenodd",
    d: "M11.25 7.5c.412 0 .75.338.75.75s-.338.75-.75.75H.75C.338 9 0 8.662 0 8.25s.338-.75.75-.75zm0-3.75c.412 0 .75.338.75.75s-.338.75-.75.75H.75C.338 5.25 0 4.912 0 4.5s.338-.75.75-.75zm0-3.75c.412 0 .75.338.75.75s-.338.75-.75.75H.75C.338 1.5 0 1.162 0 .75S.338 0 .75 0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconOrganize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-organize.42caed0052279d163fc5de4e17819e32.svg";